/*
  AoA · Cajón de filtros según el sistema de diseño (Bryan, 2026-10-14; camino 1: todo en el tema, sin tocar Search &
  Discovery ni main). Delegación en document porque facets.js reemplaza el HTML del cajón con cada filtro.
  - Familias de color (snippets/aoa-facets-color.liquid): la casilla visible no tiene name; al cambiar, copia su estado
    a las casillas ocultas de sus colores y el formulario viaja con todos (OR dentro del mismo filtro).
  - Cajas de precio (snippets/aoa-facets-price.liquid): rellenan los inputs ocultos gte/lte y disparan el envío.
  - Chip activo por familia (snippets/facets-active.liquid): al quitarlo salen todos los colores de la familia.
*/
(function () {
  'use strict';
  function submit(el) {
    var form = el.closest('form');
    if (form) form.dispatchEvent(new Event('input', { bubbles: true }));
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.classList || !t.classList.contains('aoa-family__toggle')) return;
    var li = t.closest('.aoa-family'); if (!li) return;
    li.querySelectorAll('.aoa-family__value').forEach(function (v) { if (!v.disabled) v.checked = t.checked; });
    submit(t);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.aoa-price-box'); if (!b) return;
    var wrap = b.closest('[data-aoa-price]'); if (!wrap) return;
    var gte = wrap.querySelector('input[name$="price.gte"]'), lte = wrap.querySelector('input[name$="price.lte"]');
    var pressed = b.getAttribute('aria-pressed') === 'true';
    wrap.querySelectorAll('.aoa-price-box').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
    if (pressed) {
      gte.value = ''; gte.disabled = true; lte.value = ''; lte.disabled = true;
    } else {
      b.setAttribute('aria-pressed', 'true');
      gte.value = b.dataset.gte; gte.disabled = !b.dataset.gte;
      lte.value = b.dataset.lte; lte.disabled = !b.dataset.lte;
    }
    submit(b);
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.aoa-family-chip'); if (!a) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var values = (a.dataset.aoaFamilyValues || '').split('|');
    var name = a.dataset.aoaParam;
    var current = new URLSearchParams(location.search), out = new URLSearchParams();
    current.forEach(function (v, k) { if (k === name && values.indexOf(v) !== -1) return; out.append(k, v); });
    // facets.js declara «class FacetFiltersForm» en el ámbito global del script (no cuelga de window): se consulta por nombre
    if (typeof FacetFiltersForm === 'function' && typeof FacetFiltersForm.renderPage === 'function') {
      if (FacetFiltersForm.toggleActiveFacets) FacetFiltersForm.toggleActiveFacets();
      FacetFiltersForm.renderPage(out.toString());
    } else {
      location.href = location.pathname + (out.toString() ? '?' + out.toString() : '');
    }
  }, true);
})();
